import type { WatchSource } from "vue";

export const useClickOutside = (el: WatchSource<Nullable<HTMLElement>>, handler: (e: MouseEvent) => void) => {
  const unlisten = ref<() => void>();

  watch(
    [el],
    ([container]) => {
      if (unlisten.value) unlisten.value();

      if (!container) return;

      const clickOutsideHandler = (event: MouseEvent) => {
        const target = event.target as HTMLElement;

        if (!(container === target || container.contains(target))) {
          handler(event);
        }
      };

      document.body.addEventListener("click", clickOutsideHandler);

      unlisten.value = () => {
        document.body.removeEventListener("click", clickOutsideHandler);

        unlisten.value = undefined;
      };
    },
    { immediate: true }
  );

  onUnmounted(() => unlisten.value && unlisten.value());
};
